import { Flex, Typography } from "@p0security/ui";
import type { ComponentProps, ReactNode } from "react";

export const FormRow: React.FC<{ children?: ReactNode }> = ({ children }) => (
  <Flex align="baseline" gap={12} wrap className="max-w-full min-w-5 w-full">
    {children}
  </Flex>
);

type LabelProps = Omit<ComponentProps<typeof Typography.Text>, "type"> & {
  width?: 18 | 20 | 24 | 30;
};

const WIDTH_CLASS: Record<NonNullable<LabelProps["width"]>, string> = {
  18: "min-w-18",
  20: "min-w-20",
  24: "min-w-24",
  30: "min-w-30",
};

export const RowLabel: React.FC<LabelProps> = ({
  width = 18,
  className,
  ...rest
}) => (
  <Typography.Text
    type="secondary"
    className={`inline-block ${WIDTH_CLASS[width]} ${className ?? ""}`}
    {...rest}
  />
);
